import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useCallback } from 'react';
import { Stage } from '@pixi/react';

import { gameService } from '../../../services/gameService';

import { isMobile } from '../../../core/helpers/isMobile';
import { resizeGameHandler } from '../../../core/helpers/resizeGameHandler';
import { getBrowserVisibilityProp } from '../../../core/helpers/documentVisibility';

import GameViewWrapper from '../gameViewWrapper';
import Loading from '../../../components/web/loading';
import { SoundWatcher } from '../../../components/common/soundWatcher';

const GameStage = observer(() => {
  const refApp = useRef(null);

  useEffect(() => {
    resizeGameHandler();
    window.addEventListener('resize', resizeGameHandler);
    window.__PIXI_APP__ = refApp.current.app;
    refApp.current.app.view.width = isMobile() ? window.innerWidth * 2 : 1440 * 1.5;
    refApp.current.app.view.height = isMobile() ? window.innerHeight * 2 : 810 * 1.5;
  }, []);

  const onVisibilityChange = useCallback(() => {
    gameService.visibilityChangeHandler();
  }, []);

  useEffect(() => {
    const visibilityChange = getBrowserVisibilityProp();
    document.addEventListener(visibilityChange, onVisibilityChange, false);
    gameService.checkUserActiveStat();
    document.addEventListener('click', gameService.checkUserActiveStat);
    return () => {
      document.removeEventListener(visibilityChange, onVisibilityChange);
      document.removeEventListener('click', gameService.checkUserActiveStat);
    };
  }, [onVisibilityChange]);

  return (
    <div className={isMobile() ? 'canvas-wrapper' : 'canvas-web-wrapper'}>
      <Stage
        ref={refApp}
        width={isMobile() ? window.innerWidth : 1440}
        height={isMobile() ? window.innerHeight : 810}
        options={
          isMobile()
            ? { transparent: true, backgroundAlpha: 0, resolution: 2 }
            : { transparent: true, resolution: 1.5 }
        }
      >
        <Loading>
          <GameViewWrapper />
        </Loading>
      </Stage>
      <SoundWatcher />
    </div>
  );
});

export default GameStage;
